export const SectionHeadingFontFamily = Styles.fontFamily.brand;
